import React from "react";
import { Card } from "primereact/card";
import { Image } from "primereact/image";
import pic1 from "./widgets/CommentsFilter.png";

export default function  FilterCommentsWidgetPic() {
  return (
    <div className="grid widget-section">
      <div className="col-12 md:col-12">
        <Card className="shadow-3 widget-card">
          <Image
            src={pic1}
            alt="Filter Comments"
            preview
          />
        </Card>
      </div>
    </div>
  );
}
